import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  /** Lucide icon to display */
  icon?: LucideIcon;
  /** Heading text */
  title: string;
  /** Descriptive text */
  description?: string;
  /** Action button(s) */
  action?: React.ReactNode;
  className?: string;
}

function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center",
        "rounded-[var(--radius-xl)] border border-dashed border-[var(--color-border-default)]",
        "px-[var(--space-6)] py-[var(--space-12)]",
        "text-center",
        className
      )}
    >
      {Icon && (
        <div className="mb-[var(--space-4)] flex size-14 items-center justify-center rounded-[var(--radius-full)] bg-[var(--color-primary-subtle)]">
          <Icon
            className="size-7 text-[var(--color-primary)]"
            aria-hidden="true"
          />
        </div>
      )}
      <h3 className="text-[length:var(--font-size-lg)] font-[number:var(--font-weight-semibold)] text-[var(--color-text-primary)]">
        {title}
      </h3>
      {description && (
        <p className="mt-[var(--space-1)] max-w-md text-[length:var(--font-size-sm)] text-[var(--color-text-muted)]">
          {description}
        </p>
      )}
      {action && <div className="mt-[var(--space-4)]">{action}</div>}
    </div>
  );
}

export { EmptyState };
export type { EmptyStateProps };
